import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "file",
  "use": "file-usage",
  "viewBox": "0 0 18 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 24\" id=\"file\"><path fill-rule=\"evenodd\" d=\"M17.34 4.593L13.405.66A2.25 2.25 0 0011.817 0H2.25A2.257 2.257 0 000 2.254V21.75A2.25 2.25 0 002.25 24h13.5A2.25 2.25 0 0018 21.75V6.186a2.26 2.26 0 00-.66-1.593zm-1.773 1.41H12V2.438l3.567 3.567zM2.25 21.75V2.254h7.5v4.874c0 .624.502 1.125 1.125 1.125h4.875V21.75H2.25z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol